import { DatePipe } from '@angular/common';
import { Component, LOCALE_ID, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DateUtility } from '../../../date.utility';
import { DateFormatType } from '../../../enums/date-format-type.enum';
import { TranslateService } from '@ngx-translate/core';
import { ReturnRequestType } from '../../../enums/return-request-type.enum';
import { AppMediatorService } from '../../../services/app-mediator.service';
import { sumOfArray } from '../../../utils/sumOfArray.util';

@Component({
    standalone: false,
    selector: 'por-request-cell-renderer',
    template: `
        <span [innerHTML]="cellValue"></span>
    `
})
export class RequestCellRendererComponent implements ICellRendererAngularComp {
    private readonly translateService = inject(TranslateService);
    private readonly appMediatorService = inject(AppMediatorService);
    private readonly date = inject(DatePipe);

    public cellValue!: string;
    dateFormat = '';
    constructor() {
        const locale = inject(LOCALE_ID);

        this.dateFormat = DateUtility.getDateDisplayFormat(DateFormatType.StandardDate, locale);
    }

    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        this.cellValue = this.getValueToDisplay(params);
        const lang = this.appMediatorService.localStorageService.selectedContentLanguage;
        if (lang && lang !== this.translateService.getCurrentLang()) {
            this.translateService.use(lang);
        }
    }

    // gets called whenever the user gets the cell to refresh
    refresh(params: ICellRendererParams) {
        // set value into cell again
        this.cellValue = this.getValueToDisplay(params);
        return true;
    }

    getValueToDisplay(params: ICellRendererParams) {
        const requestDate = this.date.transform(params.value, this.dateFormat);
        let requestStr = this.translateService.instant('CallOff');
        if (params.data?.callOffQty && Array.isArray(params.data?.callOffQty)) {
            const callOffQty: number = sumOfArray(params.data.callOffQty);
            requestStr = `${requestStr} ${callOffQty}/${params.data.actualQuantity}`;
        }
        if ((params.data.requestType as string) === (ReturnRequestType.Service as string)) {
            requestStr = this.translateService.instant('RequestService');
        }
        return requestDate ? `${requestStr}<br>${requestDate}` : '';
    }
}
